const actions = {
  SET_SEARCH: "SET_SEARCH",
  SET_CART_QTY: "SET_CART_QTY",
  SET_WISHLIST_QTY: "SET_WISHLIST_QTY",
  SET_IS_AUTHENCTICATED: "SET_IS_AUTHENTICATED",
  SHOW_MOBILE_SEARCH: "SHOW_MOBILE_SEARCH",
  SET_TAX_EXPIRY: "SET_TAX_EXPIRY",
  SET_TOB_EXPIRY: "SET_TOB_EXPIRY",
};
//Reducer to Handle Actions
const reducer = (state, action) => {
    switch (action.type) {
      case actions.SET_SEARCH:
        return {
          ...state,
          search: action.query,
        };

      case actions.SET_CART_QTY:
        return {
          ...state,
          cart_qty: action.qty,
        };

      case actions.SET_WISHLIST_QTY:
        return {
          ...state,
          wishlist_qty: action.qty,
        };

      case actions.SET_IS_AUTHENCTICATED:
        return {
          ...state,
          is_authenticated: action.value,
        };
      case actions.SHOW_MOBILE_SEARCH:
        return {
          ...state,
          show_mobile_search: action.value,
        };
      case actions.SET_TAX_EXPIRY:
        return {
          ...state,
          tax_expiry: action.value,
        };
      case actions.SET_TOB_EXPIRY:
        return {
          ...state,
          tob_expiry: action.value,
        };

      default:
        return state;
    }
  };

export default reducer;